import type { ItemEffect } from '@/types/effects'

function areMappedEffectsCompatible(displayEffect: ItemEffect, targetEffect: ItemEffect): boolean {
  if (displayEffect.effect.type !== targetEffect.effect.type) {
    return false
  }

  if (displayEffect.effect.type === 'gpu-effect' && targetEffect.effect.type === 'gpu-effect') {
    return displayEffect.effect.gpuEffectType === targetEffect.effect.gpuEffectType
  }

  return true
}

export function getMappedSelectionEffectEntry(
  displayEffects: ItemEffect[],
  itemEffects: ItemEffect[] | undefined,
  displayEffectId: string,
): ItemEffect | null {
  const displayEffect = displayEffects.find((effect) => effect.id === displayEffectId)
  if (!displayEffect || !itemEffects) {
    return null
  }

  const compatibleDisplayEffects = displayEffects.filter((effect) =>
    areMappedEffectsCompatible(displayEffect, effect),
  )
  const compatibleTargetEffects = itemEffects.filter((effect) =>
    areMappedEffectsCompatible(displayEffect, effect),
  )

  const compatibleIndex = compatibleDisplayEffects.findIndex((effect) => effect.id === displayEffectId)
  if (compatibleIndex < 0) {
    return null
  }

  return compatibleTargetEffects[compatibleIndex] ?? null
}
